<template>
    <div class="footer-container">
        <div class="footer-box">
            <div class="fline">
                <div class="f0">
                    <div class="infos-box icon-sty24 pl-0">
                        <img v-lazy="iconObj.icon_com" alt="" />{{ $t('index.company_name') }}
                    </div>
                    
                    <div class="infos-box icon-sty24">
                        <img v-lazy="iconObj.icon_mail" alt="" />
                        <el-tooltip class="item" effect="dark" content="请将#替换为@" placement="top">
                            <span>{{ $t('index.email_colin') }}</span>
                        </el-tooltip>
                    </div>
                    
                    <div class="infos-box icon-sty24">
                        <img v-lazy="iconObj.icon_local" alt="" />{{ $t('index.company_address') }}
                    </div>
                    
                    <div class="infos-box icon-sty36 pl-0" style="display:none;">
                        <div class="icon-sty36-box">
                            <img v-lazy="iconObj.icon_follow" alt="" />{{ $t('index.follow_us') }}
                        </div>

                        <div class="icon-sty36-box rw">
                            <img v-lazy="iconObj.icon_facebook" alt="" @click="gotoWebsite('facebook')" />
                            <img v-lazy="iconObj.icon_youtube" alt="" @click="gotoWebsite('youtube')" />
                            <img v-lazy="iconObj.icon_instagram" alt="" @click="gotoWebsite('instagram')" />
                            <img v-lazy="iconObj.icon_twitter" alt="" @click="gotoWebsite('twitter')" />
                            <img v-lazy="iconObj.icon_linkin" alt="" @click="gotoWebsite('linkin')" />
                        </div>
                    </div>
                </div>
                
                <div class="f1" v-if="isHideForTest">
                    <img v-lazy="iconObj.logo_w" alt="" @click="goHome()" />
                </div>
            </div>

            <div class="fline m20">
                <div class="f2">
                    {{ $Common.toSprintf($t('index.copyright'), thisYear) }}

                    <span class="copyrightInfo">
                        <a href="https://store.soofun.online/static/images/icp/b2-20250845.png" rel="noreferrer" target="_blank" class="gwabSty">
                            增值电信业务经营许可证鲁B2-20250845
                        </a>
                    </span>

                    <span class="copyrightInfo">
                        <a href="http://beian.miit.gov.cn" target="_blank">
                            鲁ICP备2024134595号-1
                        </a>
                    </span>
                
                    <span class="copyrightInfo">
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37091102000870" rel="noreferrer" target="_blank" class="gwabSty">
                            <img v-lazy="iconObj.icon_gwab" class="iconGwab" />
                            鲁公网安备37091102000870号
                        </a>
                    </span>

                    <span class="copyrightInfo">
                        <a href="javascript:;" rel="noreferrer" target="_blank" class="gwabSty">
                            国新出审[2021]410号 ISBN 978-7-498-08872-7
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * Common Right Contact Us
 */
/* import contactWechatImg  from '@/../public/static/imgs/wechat/summer.png';
import contactDemoAppImg from '@/../public/static/imgs/wechat/demo-app.png'; */
import { mapState } from 'vuex';
import { goToHome } from '@/utils/routerUtils';

export default {
    name: 'CommonBottomFooterMenu',
    data() {
        return {
            // contactWechatImg,
            // contactDemoAppImg,
            tips   : 'Hello World',
            iconObj: {
				icon_com      : require('@/assets/static/imgs/common/icon_com.png'),
				icon_mail     : require('@/assets/static/imgs/common/icon_mail.png'),
				icon_local    : require('@/assets/static/imgs/common/icon_local.png'),
				icon_follow   : require('@/assets/static/imgs/common/icon_follow.png'),
				icon_facebook : require('@/assets/static/imgs/common/icon_facebook.png'),
				icon_youtube  : require('@/assets/static/imgs/common/icon_youtube.png'),
				icon_instagram: require('@/assets/static/imgs/common/icon_instagram.png'),
				icon_twitter  : require('@/assets/static/imgs/common/icon_twitter.png'),
				icon_linkin   : require('@/assets/static/imgs/common/icon_linkin.png'),
				logo_w        : require('@/assets/static/imgs/common/logo-w.png'),
				icon_gwab     : require('@/assets/static/imgs/common/icon_gwab.png')
			}
        }
    },

    methods: {
        handleError(event)
        {
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        },

        // 跳转至首页
		goHome()
		{
			goToHome(this.$router);
		},

        gotoWebsite(type)
        {
            switch(type)
            {
                case 'facebook':
                    window.open('https://www.facebook.com/profile.php?id=61557913743944');
                    break;
                case 'youtube':
                    window.open('https://www.youtube.com/channel/UCB2i266KFFcfmfiUTX5mk7g');
                    break;
                case 'instagram':
                    window.open('https://www.instagram.com/bytesungame/');
                    break;
                case 'twitter':
                    window.open('https://twitter.com/BytesunGame');
                    break;
                case 'linkin':
                    window.open('https://www.linkedin.com/company/bytesun-game/?viewAsMember=true');
                    break;
            }
        }
    },
    computed: {
        // ES6展开合并运算符
		...mapState(['isHideForTest']),

		thisYear()
        {
            return new Date().getFullYear();
        }   
	}
}
</script>

<style lang="less" scoped>
.footer-container{
    display:flex;justify-content:center;align-items:flex-start;
    width:100%;height:auto;
    background:#13144D;
    .footer-box{
        width:var(--com-base-container-w);height:inherit;
        padding-top:40px;
        font-family:var(--com-number-coin-fm-L);font-size:var(--com-base-fz-14);text-align:center;
        .fline{
            display:flex;justify-content:space-between;align-items:center;
            .f0, .f1{
                height:inherit;
                /* background:rgba(148, 148, 148, .07); */
                div{
                    font-family:var(--com-number-coin-fm-R);color:#FFF;/* font-weight:bold; */
                }
            }
            .f0{
                display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;
                width:75%;
                font-size:var(--com-base-fz-20);text-align:left;
                .infos-box{
                    display:flex;justify-content:flex-start;align-items:center;
                    height:45px;
                }
                .pl-0{
                    padding-left:0px;
                }
                .icon-sty24{
                    img{
                        width:24px;height:24px;
                        margin-right:7px;
                    }
                    span{
                        font-size:var(--com-base-fz-20);color:#FFF;
                    }
                }
                .icon-sty36{
                    margin-top:15px;
                    .icon-sty36-box{
                        width:auto;height:36px;
                        display:flex;justify-content:flex-start;align-items:center;
                        img{
                            width:24px;height:24px;
                            margin-right:7px;
                        }
                    }
                    .rw{
                        margin-left:40px;
                        img{
                            width:36px;height:36px;
                            margin-right:37px;
                            cursor:pointer;
                        }
                    }
                }
                .channels-list-box{
                    width:290px;
                    padding:15px;
                    display:flex;align-items:flex-start;flex-wrap:wrap;
                    gap:40px 40px;
                    i{
                        width:60px;height:60px;
                        font-size:var(--com-base-fz-50);color:#000;
                    }
                }
            }
            .f1{
                display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
                width:25%;
                img{
                    width:102px;height:44px;
                    cursor:pointer;
                }
                .f1-1, .f1-2, .f1-3{
                    width:300px;height:60px;line-height:60px;
                    background:rgba(148, 148, 148, .07);
                    color:#FFF;
                }
            }
            .f2{
                display:flex;flex-direction:row;justify-content:flex-start;align-items:center;
                padding-left:31px;
                border-top:2px solid #2B2C68;
                width:var(--com-base-container-w);height:60px;/* line-height:40px; */
                font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-14);color:#7D7EA8;text-align:left;
                .copyrightInfo{
                    margin-left:15px;
                    a{
                        font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-14);color:#7D7EA8;text-align:left;
                    }
                    .gwabSty{
                        display:flex;justify-content:flex-start;align-items:center;
                        .iconGwab{
                            margin-right:3px;width:20px;height:20px;
                        }
                    }
                }
            }
        }
    }
}
</style>
